import { useState, useEffect } from "react";
import Bmi from "./Bmi";
import BACCalculator from "./BACCalculator";
import BMRCalculator from "./BMRCalculator";
import TDEECalculator from "./TDEECalculator";
import CaloriesBurnedCalculator from "./CaloriesBurnedCalculator";
import BodyFatCalculator from "./BodyFatCalculator";
import { useGetOneUserQuery } from "../users/usersApiSlice";
import useAuth from "../../hooks/useAuth";

let Kalkulacije = () => {
  const [user, setUser] = useState("");
  const { id } = useAuth();
  const {
    isSuccess: isSuccessUser,
    isError: isErrorUser,
    error: getUserError,
    data: getUserData,
  } = useGetOneUserQuery(id);

  //Get user
  useEffect(() => {
    if (isSuccessUser) {
      // console.log("Success response:", Object.values(getUserData.entities || {}));

      setUser(getUserData);

      // console.log('User', getUserData)

      // data objekat je dobar response message
      // const successMessage = getUserData?.message
    }

    if (isErrorUser) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getUserError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessUser, isErrorUser, getUserError, getUserData]);

  return (
    <>
      <div className="flex justify-center">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border border-gray-300 p-4 rounded-lg">
          {user !== "" && (
            <>
              <BMRCalculator
                tezina={user.tezina}
                visina={user.visina}
                pol={user.pol}
                godine={
                  new Date().getFullYear() -
                  new Date(user.datumRodjenja).getFullYear() -
                  (new Date() <
                  new Date(user.datumRodjenja).setFullYear(
                    new Date(user.datumRodjenja).getFullYear()
                  )
                    ? 1
                    : 0)
                }
              />
              <TDEECalculator
                tezina={user.tezina}
                visina={user.visina}
                pol={user.pol}
                godine={
                  new Date().getFullYear() -
                  new Date(user.datumRodjenja).getFullYear() -
                  (new Date() <
                  new Date(user.datumRodjenja).setFullYear(
                    new Date(user.datumRodjenja).getFullYear()
                  )
                    ? 1
                    : 0)
                }
              />
              <CaloriesBurnedCalculator tezina={user.tezina} />
              <BodyFatCalculator
                pol={user.pol}
                visina={user.visina}
                struk={user.struk}
                vrat={user.vrat}
                kuk={user.kuk}
              />

              <BACCalculator tezina={user.tezina} pol={user.pol} />

              <Bmi tezina={user.tezina} visina={user.visina} />
            </>
          )}
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      {/* <br/> */}
    </>
  );
};

export default Kalkulacije;

{
  /* 
  <BodyFatCalculator  /> 
  <CaloriesBurnedCalculator />
  <BACCalculator />
  <BMRCalculator />
  <TDEECalculator />
  <Bmi /> 
*/
}

let user = {
  pol: "Muski",
  telefon: "0669385463",
  tezina: "75",
  visina: "183",
};
